import { Button, Flex, Input, useColorModeValue } from "@chakra-ui/react";
import React from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";

function Dropzone(props) {
  const {
    content,
    allowedExtensions = [],
    maxSizeInMB = null,
    isDisabled = false, // <-- New prop
    ...rest
  } = props;

  const bg = useColorModeValue("gray.100", "navy.700");
  const borderColor = useColorModeValue("secondaryGray.100", "whiteAlpha.100");

  const { getRootProps, getInputProps, open } = useDropzone({
    disabled: isDisabled, // <-- Disable the dropzone functionality
    multiple: props.hasOwnProperty("isMultipleAllow")
      ? props.isMultipleAllow
      : true,
    noClick: isDisabled, // Optional: prevents click from opening file dialog
    noDrag: isDisabled,  // Optional: disables drag & drop
    onDrop: (acceptedFiles) => {
      const invalidFiles = acceptedFiles.filter((file) => {
        let isInvalid = false;
        const fileExtension = file.name.split(".").pop().toLowerCase();
        const fileSizeInMB = file.size / 1024 / 1024;

        if (
          allowedExtensions.length > 0 &&
          !allowedExtensions.includes(fileExtension)
        ) {
          toast.error(
            `Please upload a file with one of the following extensions: ${allowedExtensions.join(", ")}.`
          );
          isInvalid = true;
        }

        if (maxSizeInMB && fileSizeInMB > maxSizeInMB) {
          toast.error(`File size must be ≤ ${maxSizeInMB}MB.`);
          isInvalid = true;
        }

        return isInvalid;
      });

      if (invalidFiles.length > 0) {
        props.onFileSelect(null, "Invalid file(s) selected");
      } else {
        props.onFileSelect(acceptedFiles);
      }
    },
  });

  return (
    <Flex
      align="center"
      justify="center"
      bg={bg}
      padding={2}
      border="1px dashed"
      borderColor={isDisabled ? "gray.300" : borderColor}
      borderRadius="16px"
      opacity={isDisabled ? 0.6 : 1}
      w="100%"
      minH="100%"
      cursor={isDisabled ? "not-allowed" : "pointer"}
      {...getRootProps({ className: "dropzone" })}
      {...rest}
    >
      <Input
        type="file"
        variant="main"
        multiple
        disabled={isDisabled} // <--- Important!
        {...getInputProps()}
      />
      <div isDisabled={isDisabled ? true : false} // <--- Optional visual support
        onClick={(e) => {
          if (isDisabled) e.preventDefault();
        }}>{content}</div>
    </Flex>
  );
}

export default Dropzone;
